import React, { useRef, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Visibility } from '@material-ui/icons';

import { ADM, GFE } from '~/constants/perfil';
import { UnidataTable } from '~/components';

import {
  findOperacaoVeiculoManutencaoUnidata,
  recordFiltering,
} from '~/store/modules/operacaoveiculomanutencaounidata/actions';

import DetalheVeiculo from './components/DetalheVeiculo';

import { number } from '~/helpers';

import OperacaoVeiculoManutencaoUnidataForm from './form';

function OperacaoVeiculoManutencaoUnidata() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);
  const buttons = [];

  const operacaoveiculomanutencaounidata = useSelector(
    (state) => state.operacaoveiculomanutencaounidata
  );

  const listaVeiculosRef = useRef(null);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.glousuariotipo) {
        case ADM:
        case GFE:
          break;
        default:
          break;
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(operacaoveiculomanutencaounidata.paramss));
  }, [operacaoveiculomanutencaounidata.params]);

  const header = useMemo(
    () => [
      {
        id: 'veic_placa_aux',
        label: 'Veículo',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_codigo',
        label: 'Cód Órgão',
        filter: {
          type: 'number',
        },
        align: 'left',
      },
      {
        id: 'unid_codigo',
        label: 'Cód Unidade',
        filter: {
          type: 'number',
        },
        align: 'left',
      },
      {
        id: 'veic_status',
        label: 'Status',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'desc_veic_em_manutencao',
        label: 'Em Manutenção',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'desc_veic_em_afericao',
        label: 'Em Aferição',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_nome',
        label: 'Desc Órgão',
        align: 'left',
      },
      {
        id: 'unid_nome',
        label: 'Desc Unidade',
        align: 'left',
      },
      {
        id: 'vemm_codigo',
        label: 'Cód Modelo',
        align: 'left',
      },
      {
        id: 'vemm_nome',
        label: 'Marca/Modelo',
        align: 'left',
      },
      {
        id: 'veic_ano_modelo',
        label: 'Ano Modelo',
        align: 'left',
      },
      {
        id: 'veic_ano_fabricacao',
        label: 'Ano Fabricação',
        align: 'left',
      },
      {
        id: 'veic_renavam',
        label: 'Renavam',
        align: 'left',
      },
      {
        id: 'veic_volume_tanque',
        label: 'Vol Tanque',
        align: 'left',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'veic_totalizador',
        label: 'Totalizador',
        align: 'left',
        formatted: (value) => number(value, 1),
      },
      {
        id: 'veic_hodentrecadaconfirm',
        label: 'Hodômetro confirm.',
        align: 'left',
      },
      {
        id: 'veic_afericao_dvec',
        label: 'Aferição DVEC',
        align: 'left',
      },
      // {
      //   id: 'vedv_contador_desc',
      //   label: 'Tipo DVEC',
      //   align: 'left',
      // },
      // {
      //   id: 'vedv_contador_permite',
      //   label: 'Permite incluir em aferição',
      //   align: 'left',
      // },
      {
        id: 'veic_possui_transp',
        label: 'Possui Transp',
        align: 'left',
      },
      {
        id: 'veic_tag1',
        label: 'Transp 01',
        align: 'left',
      },
      {
        id: 'veic_tag2',
        label: 'Transp 02',
        align: 'left',
      },
      {
        id: 'veic_idxbee',
        label: 'DVEC',
        align: 'left',
      },
    ],
    []
  );

  const headerbuttons = useMemo(
    () => [
      buttons.push({
        title: 'Detalhe',
        action: (value) => listaVeiculosRef.current.handleToggleModal(value),
        icon: <Visibility />,
      }),
    ],
    [operacaoveiculomanutencaounidata]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="veic_placa_aux ASC"
        title={'Veículo Manutenção Abastek'}
        create={false}
        delete={false}
        fixed
        header={header}
        form={OperacaoVeiculoManutencaoUnidataForm}
        find={findOperacaoVeiculoManutencaoUnidata}
        redux={operacaoveiculomanutencaounidata}
        read={recordFiltering}
        actions={buttons}
        detach="veic_placa_aux"
        keys={['veic_placa']}
        view="VW_VEICULO"
        reportTitle="Veículo Manutenção Abastek"
      />

      <DetalheVeiculo
        ref={listaVeiculosRef}
        update={() => handleUpdate()}
        name="detalhe"
      />
    </>
  );
}

export default OperacaoVeiculoManutencaoUnidata;
